import LogOutIcon from './log-out-icon';
export default LogOutIcon;
